var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",null,null,Object.assign({}, _vm.$data,
            {methods: {
                initializeEmbed: _vm.initializeEmbed,
                setGlobalConfig: _vm.setGlobalConfig,
                destroyPlayer: _vm.destroyPlayer,
                setEmbedSetting: _vm.setEmbedSetting,
            }}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }